import * as React from "react";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import { Result, UploadState } from "../Map/enums";
import "./SubmitForm.scss";

export interface ISubmitStatus {
    name: UploadState | string;
    result: Result;
}
interface IUploadStates {
    [fileName: string]: Result;
}

export const SubmitForm = ({
    submitStatus,
    completed
}: {
    submitStatus: ISubmitStatus;
    completed: Result | undefined;
}): JSX.Element => {
    const [uploadStates, setUploadStates] = useState<IUploadStates>({});

    const { attachments, drawnFeatures } = useRegistrationContext();

    useEffect(() => {
        const newState = { ...uploadStates };
        if (submitStatus && submitStatus.name) {
            newState[submitStatus.name] = submitStatus.result;

            // if uploadPDF fails, set Error for all next steps
            if (submitStatus.name === UploadState.UploadPdf && submitStatus.result === Result.Error) {
                newState[UploadState.SubmitForm] = Result.Error;
                newState[UploadState.SendEmail] = Result.Error;
            }
        }
        setUploadStates(newState);
    }, [submitStatus]);

    return (
        <div className="submit-form">
            <div className="submit-section">
                {drawnFeatures && drawnFeatures.length ? (
                    <StatusItem
                        states={uploadStates}
                        itemStatusName={UploadState.UploadGeometries}
                        titles={{
                            default: "Norises vietas pievienošana",
                            success: "Norises vieta pievienota",
                            error: "Norises vietu neizdevās pievienot"
                        }}
                    ></StatusItem>
                ) : null}
                {attachments && (
                    <>
                        {Array.from(attachments, (attachment) => (
                            <StatusItem
                                key={attachment.name + "statusitem"}
                                states={uploadStates}
                                itemStatusName={attachment.name}
                                titles={{
                                    default: attachment.name,
                                    success: attachment.name,
                                    error: attachment.name
                                }}
                            ></StatusItem>
                        ))}
                    </>
                )}
                <StatusItem
                    states={uploadStates}
                    itemStatusName={UploadState.CreatePdf}
                    titles={{
                        default: "Atskaites gatavošana",
                        success: "Atskaite sagatavota",
                        error: "Atskaiti neizdevās sagatavot"
                    }}
                ></StatusItem>
                <StatusItem
                    states={uploadStates}
                    itemStatusName={UploadState.UploadPdf}
                    titles={{
                        default: "Atskaites pievienošana",
                        success: "Atskaite pievienota",
                        error: "Atskaiti neizdevās pievienot"
                    }}
                ></StatusItem>
                <StatusItem
                    states={uploadStates}
                    itemStatusName={UploadState.SubmitForm}
                    titles={{
                        default: "Anketas datu reģistrēšana",
                        success: "Anketa reģistrēta",
                        error: "Anketu neizdevās piereģistrēt"
                    }}
                ></StatusItem>
                <StatusItem
                    states={uploadStates}
                    itemStatusName={UploadState.SendEmail}
                    titles={{
                        default: "Atskaites sūtīšana",
                        success: "Atskaite nosūtīta",
                        error: "Atskaiti neizdevās nosūtīt"
                    }}
                ></StatusItem>
                <div className={classNames("attachment-subtitle", { error: completed === Result.Error })}>
                    {completed === undefined
                        ? "Datu pievienošana..."
                        : completed === Result.Success
                        ? "Pieteikums iesniegts!"
                        : "Pieteikums nav iesniegts."}
                </div>
            </div>
        </div>
    );
};

interface IStatusItem {
    states: IUploadStates;
    itemStatusName: UploadState | string;
    titles: { default: string; success: string; error: string };
}

const StatusItem = ({ states, itemStatusName, titles }: IStatusItem) => (
    <div className="attachment" key={itemStatusName}>
        <div className="attachment-state">
            {states[itemStatusName] === undefined ? (
                <div className="icon-geo-spinner rotating"></div>
            ) : states[itemStatusName] === Result.Success ? (
                <div className="icon-geo-check1 check"></div>
            ) : (
                <div className="icon-geo-close-popup error"></div>
            )}
        </div>
        <div className="attachment-name">
            {states[itemStatusName] === undefined
                ? titles.default
                : states[itemStatusName] === Result.Success
                ? titles.success
                : titles.error}
        </div>
    </div>
);
